<div id="wrapper"  fxLayoutAlign="center center">
  
<form fxLayout="column" 
    (submit)="verifyUser()"
    [formGroup]="userForm"
    autocomplete="off"
  >
  <div class="login-form-flex">
    <mat-card>
      <mat-card-title class="text-center">
        <img src="./assets/img/logo.png" />
        <h2 class="text-center">Gestor de Almacén</h2>
      </mat-card-title>
      <mat-card-content>
        <mat-form-field>
          <input matInput placeholder="Usuario" name="username"
          formControlName="username">
        </mat-form-field>
        <br/>
        <mat-form-field>
          <input type="password" matInput placeholder="Contrase&ntilde;a"
          name="pass" formControlName="pass"/>
        </mat-form-field>

      </mat-card-content>

      <mat-card-actions>
        <div class="button-flex-container">
          <button mat-raised-button color="primary" fxFlex="100%" [disabled]="this.userForm.invalid">INGRESAR</button>
        </div>
        <div class="button-flex-container-forgot">
          &nbsp;
        </div>
        <small>v 1.4.1</small>
      </mat-card-actions>
    </mat-card>
  </div>
</form>

</div>

